var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{class:_vm.buttonClass,attrs:{"type":_vm.type,"icon":_vm.icon,"long":_vm.long,"size":_vm.n_size,"ghost":_vm.ghost,"loading":_vm.loading,"disabled":_vm.disabled,"custom-icon":_vm.customIcon},on:{"click":function($event){return _vm.$emit('on-click')}}},[_vm._v(" "+_vm._s(_vm.$t(`label.${_vm.text}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }